// extracted by mini-css-extract-plugin
export var fadeInAnimation = "TagCounter-module--fadeInAnimation--1bc4e";
export var item = "TagCounter-module--item--79e2d";
export var itemTitle = "TagCounter-module--itemTitle--ecb74";
export var tag = "TagCounter-module--tag--380d8";